import { Controller } from "@hotwired/stimulus"
import { getWindowWidth } from "web/services/browser"
import {
  applyMenuPosition,
  calculateHorizontalPosition,
  calculateVerticalPosition,
} from "helpers/dropdown_positioning"

const FULL_SCREEN_BREAKPOINT = 768

export default class DropdownController extends Controller {
  static targets = ["menu", "trigger"]

  connect() {
    this.boundUpdatePositionHandler = this.updatePosition.bind(this)

    window.addEventListener("resize", this.boundUpdatePositionHandler)
  }

  disconnect() {
    window.removeEventListener("resize", this.boundUpdatePositionHandler)
  }

  toggle() {
    if (!this.hasMenuTarget) return

    this.menuTarget.classList.toggle("hidden")

    const windowWidth = getWindowWidth()
    const showFullScreenDropdown = windowWidth < FULL_SCREEN_BREAKPOINT

    if (
      !showFullScreenDropdown &&
      !this.menuTarget.classList.contains("hidden")
    ) {
      this.updatePosition()
    }
  }

  hide(event) {
    if (!this.hasMenuTarget) return
    if (!this.element.contains(event.target)) {
      this.menuTarget.classList.add("hidden")
    }
  }

  updatePosition() {
    if (!this.hasMenuTarget || !this.hasTriggerTarget) return

    const triggerRect = this.triggerTarget.getBoundingClientRect()
    const menuRect = this.menuTarget.getBoundingClientRect()

    const top = calculateVerticalPosition(triggerRect, menuRect)
    const left = calculateHorizontalPosition(triggerRect.left, menuRect)

    applyMenuPosition(this.menuTarget, top, left)

    requestAnimationFrame(this.boundUpdatePositionHandler)
  }
}
